import { DEPLOYMENT_ENVIRONMENT, DeploymentEnvironment } from 'env/environments';
import { getHomeLoansDashboardRuntimeConfig } from 'src/services/config/getHomeLoansDashboardRuntimeConfig';

const REDIRECT_EXEMPTED_ENVIRONMENTS: Partial<DeploymentEnvironment>[] = [
    // If we redirect off local, we can't develop locally
    DEPLOYMENT_ENVIRONMENT.LOCAL,
    // There is no Zillow domain to redirect to in dev
    DEPLOYMENT_ENVIRONMENT.DEVELOPMENT,
];

/**
 * Co-effects: Relies on Next Config
 *
 * Returns whether the current deployment and runtime environment is exempt from requiring a redirect to a Zillow
 * domain
 */
export const isCurrentRuntimeEnvironmentRedirectExempt = (): boolean => {
    const { publicRuntimeConfig } = getHomeLoansDashboardRuntimeConfig();
    const { ENV, isMergeRequest } = publicRuntimeConfig;

    return REDIRECT_EXEMPTED_ENVIRONMENTS.includes(ENV) || isMergeRequest;
};
